export const L10nTemplates = /** @type {const} */ {
  templates: 'Templates',
  changeTemplate: 'Change Template',
  currentTemplate: 'Current template',
  myTemplates: 'My templates',
  organizationTemplates: 'Organization templates',
  avomaTemplates: 'Avoma templates',
  createANewTemplate: 'New Template',
  createNewCollection: 'New Collection',
  searchPlaceholder: 'Search for a template..',
  expandSidebar: 'Expand sidebar',
  currentlyInUse: 'Currently in use',
  renameTemplateName: 'Update title',
  renameTemplateDescription: 'Update description',
  edit: 'Edit',
  applyTemplate: 'Apply template',
  previewNotes: 'Preview notes',
  previewTemplate: 'Preview template',
  templatePreview: 'Template Preview',
  createdBy: 'Created by:',
  lastModified: 'Last modified',
  assignedTo: 'Assigned to:',
  noPurposesAssigned: 'No purposes assigned',
  defaultTemplateSwitchTitle: 'Set as my default',
  organizationDefaultTemplateSwitchTitle: "Set as my organization's default",
  promptTitle: 'Prompt',
  notesFormatTitle: 'Notes format:',
  crmMappingTitle: 'CRM Mapping',
  backToTemplate: 'Back to template',
  selectDifferentMeeting: 'Select a different meeting',
  emptyTemplateMessageWithAuthority:
    'No Smart Topics have been added to this template. Please edit to add Smart Topics.',
  emptyTemplateMessageWithoutAuthority: 'Notes template is empty.',
  noAccessMessage:
    'You do not have permission to access this private template.',
  notAvailable: 'N/A',
  readOnly: 'Read-only',
  readOnlyTooltip:
    'This template can be duplicated or used for meetings but cannot be edited or deleted',
  participants: 'Participants',
  participantsDescription: 'List of participants from the conversation.',
  aiDetectedTopics: 'AI Detected Topics',
  aiDetectedTopicsDescription:
    'Avoma AI will generate notes for all the relevant topics detected in the conversation.',
  purposeNotAllowedTooltipForAvomaDefault:
    'Purposes not allowed for Avoma Default template',
  generatingNotes: 'Generating notes...',
  applyTemplateSuccess: 'Template applied and notes generated successfully',
  associatedTemplateSuccess: 'Template applied successfully',
  applyTemplateError: 'Failed to apply template to meeting',
  generateNotesError: 'Failed to generate notes for this meeting',
  errorGeneratingNotesMessage:
    'There was an error generating notes for this meeting. Please try again.',
  noPromptPlaceholder:
    'No prompt added. Enhance this topic by providing a prompt.',
  regenerationHistoryTooltip: 'View notes regeneration history',
  searchTopicPlaceholder: 'Search for a topic',
  createNewTopic: '+ Create New Topic',
  noCategoriesFound: 'No Categories found matching search criteria',
  outdatedTemplate:
    'This template has been updated. Regenerate notes to apply these changes.',
  regenerateNotes: 'Regenerate notes',
  regeneratingNotes: 'Regenerating notes...',
  templateNotFound: 'Template not found',
  personalTemplate: 'My Personal Default',
  organizationDefaultTemplate: 'Organization Default',

  // Confirm modal strings
  setConfirmText: 'Yes, Proceed',
  setPersonalDefaultTitle: 'as your personal default template?',
  setOrgDefaultTitle: "as your organization's default template?",
  setOrgDefaultDescription:
    'Please note that default template set by the meeting owners will take precedence over this organization template',
  assignPurposeConfirmText: 'Assign Purpose',
  assignPurposeTitle: 'template?',
  assignPurposeDescription:
    'This template will be automatically applied to all meetings with the selected purpose(s), taking priority over your personal and organization default templates.',
  selectCollection: 'Select a collection',
  createTemplate: 'Create Template',
  extractAdditionalTopicsTitle: 'Choose how to extract notes',
  extractAdditionalTopicsDisabled:
    'Only topics that are defined in the template',
  extractAdditionalTopicsEnabled: 'For all relevant topics',
  extractAdditionalTopicsConfirmModalTitle: 'Choose how to extract notes',
  extractAdditionalTopicsConfirmModalText: () => (
    <div className='flex flex-col gap-y-2'>
      <span>
        When enabled, future meetings using this template will{' '}
        <strong>
          only capture notes for the specific topics you've predefined
        </strong>
        .
      </span>
      <span>
        Topics not included in your template will be{' '}
        <strong>ignored during note extraction</strong>.
      </span>
      <span>Do you wish to proceed?</span>
    </div>
  ),
  templatePurposesUpdatedSuccessfully: 'Template purposes updated successfully',
  defaultTemplateBehavior: 'Default template behavior',
  organizeUnderSpecificCollection: 'Organize under a specific collection',
  autoApplyTemplateToMeetingsWithSelectedPurposesFor: 'Auto-apply for meetings',
  autoApplyForSelectedPurposesDescription:
    'Automatically use this template for meetings tagged with the selected purpose(s).',
  createCollectionError: 'Failed to create collection',
  updateCollectionError: 'Failed to update collection',
  templateCollectionUpdateError: 'Failed to update template collection',
  deleteDisabledTooltip:
    'Only the template owner and an Avoma admin can delete this template',

  // Template list view sections
  allTemplates: {
    getStarted: 'Get Started',
    recentlyAddedTemplates: 'Recently Added Templates',
    forInterview: 'For Interview',
    forSalesDiscoveryAndDemo: 'For Sales',
    forMarketing: 'For Marketing',
    forProduct: 'For Product',
    forRecruiting: 'For Recruiting',
    forOpsAndFinance: 'For Ops and Finance',
    forCsm: 'For CSM',
    forInternalMeetings: 'For Internal Meetings',
    popularTemplates: 'Popular Templates',
    collectionsByTeam: 'Collections By Team'
  },
  methodologyControlled: {
    autoApplied: 'Auto-applied by AI Methodology',
    methodology: 'Methodology',
    description: (methodologyName: string) =>
      `This template is automatically applied to meetings for deals in ${methodologyName}-enabled pipelines`,
    viewSettings: 'View settings'
  },
  filters: {
    collection: 'Collection',
    filterByCollection: 'Filter by Collection'
  }
};
